// import "core-js"
import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "@/store";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "@/stylus/main.styl";
import VueCharts from "vue-chartjs";
import Vuelidate from "vuelidate";
import VueWordCloud from "vuewordcloud";
import VueSession from "vue-session";
import moment from "moment";
import { DatePicker, Input, Button, Tag, Autocomplete } from "element-ui";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "element-ui/lib/theme-chalk/index.css";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import VueAnalytics from 'vue-ua';
import "@/filters";

Vue.config.productionTip = false;
if (process.env.NODE_ENV === 'development') {
	Vue.config.devtools = true
} else {
	Vue.config.devtools = false
}
locale.use(lang);
Vue.use(DatePicker, { locale });
Vue.use(Input);
Vue.use(Button);
Vue.use(Tag);
Vue.use(Autocomplete);
Vue.use(VueSession, {
    persist: true
});
Vue.use(Vuelidate);
Vue.use(VueCharts);
Vue.use(VueWordCloud);
Vue.use(Vuetify, {
    iconfont: "md" || "fa",
    theme: {
        drawercolor: "#152841",
        bindezcolor: "#29A689",
        secondarycolor: "#AFBAC8",
        negative: "#EB2929",
        neutral: "#EAC82A",
        interest: "#1F65C5",
        positive: "#1AB177"
    }
});

Vue.use(VueAnalytics, {
	appName: "Bindez Insights",
	appVersion: 154154973,
	trackingId: "UA-51716529-8",
	vueRouter: router,
	ignoreViews: ["authorizing", "notfound"],
	//trackPage: true,
});

// window.Vue = Vue;
let vm = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");

window.setInterval(() => {
    if (moment(vm.$session.get("atoken_expire_time")).diff(moment(), "hours") <= 2) {
        vm.$store.dispatch("refreshAccessToken");
    }
}, 1000 * 60 * 60);
